import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius3, space3, space6 } = theme();

  return StyleSheet.create({
    actions: {
      marginTop: space6,
      padding: space6,
    },
    commentTitle: {
      alignItems: "center",
      marginBottom: space6,
    },
    errorBanner: {
      borderRadius: borderRadius3,
      marginBottom: space6,
      padding: space3,
    },
    fieldWrapper: {
      marginBottom: space6,
    },
    link: {
      alignItems: "center",
      marginTop: space6,
    },
    productQuestions: {
      padding: space6,
      paddingBottom: 0,
    },
    productWrapper: {
      marginBottom: space6,
    },
    questionSubtitle: {
      marginBottom: 24,
      textAlign: "center",
    },
    questionTitle: {
      textAlign: "center",
    },
  });
};

export { style };
